import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

type State = {
  dimensionsMeta: any;
  dimensionByTypes: any;
  dimensionCategoryMap: any;
};

type Action = {
  setDimensionsMeta: (dimensionsMeta: State['dimensionsMeta']) => void;
};

const initialState: State = {
  dimensionsMeta: [],
  dimensionByTypes: {},
  dimensionCategoryMap: {},
};

const dimensionsStore = create(
  devtools((set: any, get: any) => ({
    ...initialState,
    setDimensionsMeta: (dimensionsMeta) =>
      set(() => {
        const dimensionByTypes = {};
        const dimensionCategoryMap = {};
        if (dimensionsMeta && dimensionsMeta.length > 0) {
          dimensionsMeta.forEach((dimension) => {
            if (dimension.type) {
              dimensionByTypes[dimension.groupBy] = dimension.type;
            }
            if (dimension.category) {
              dimensionCategoryMap[dimension.groupBy] = dimension.category;
            }
          });
        }
        return {
          dimensionsMeta,
          dimensionByTypes,
          dimensionCategoryMap,
        };
      }),
  })),
);

export default dimensionsStore;
